<template>
	<header class="header-cmp">
		<div class="dropdown">
			<a-icon
				class="collapsed-icon mr24"
				:type="aside_collapsed ? 'menu-unfold' : 'menu-fold'"
				@click="setCollapsed"
			>
			</a-icon>
			<a-dropdown>
				<a class="ant-dropdown-link">
					{{curStation}}
					<a-icon type="down"/>
				</a>
				<a-menu slot="overlay" @click="onClick">
					<a-menu-item v-for="item in selectList" :key="item.id">
						<a href="javascript:;">{{item.name}}</a>
					</a-menu-item>
				</a-menu>
			</a-dropdown>
		</div>
		<div class="header-right">
			<!-- <img class="mr8" src="../../assets/image/img_nav_photo.png" alt=""> -->
			<span class="mr16">{{userName}}</span>
			<a-dropdown>
				<a-icon type="question-circle-o" class="mr16" style="vertical-align: sub; color: rgba(0,0,0,.55); font-size: 18px" />
				<a-menu slot="overlay" style="padding: 10px">
					<a-menu-item @click="visibleErCode = true">小程序二维码</a-menu-item>
					<a-menu-item @click="visibleAppCode = true">园管下载二维码</a-menu-item>
					<a-menu-item v-for="item in list" :key="item.text" @click="goDetail(item)">{{item.text}}</a-menu-item>
				</a-menu>
			</a-dropdown>
			<span @click="modifyPassword">修改密码</span>
			<a-divider type="vertical" />
			<a-popconfirm
				title="确定退出登录吗?"
				@confirm="loginOut"
				>
				<span>退出</span>
			</a-popconfirm>
		</div>
		<a-modal title="小程序二维码" centered v-model="visibleErCode" :footer="null">
			<div class="text-center">
				<img src="https://apailang.oss-cn-hangzhou.aliyuncs.com/images/20230321/1679388736956_backImage" style="width: 250px">
			</div>
		</a-modal>
		<a-modal title="园管下载二维码" centered v-model="visibleAppCode" :footer="null">
			<div class="text-center">
				<img src="https://apailang.oss-cn-hangzhou.aliyuncs.com/images/20230321/1679388762465_backImage">
			</div>
		</a-modal>
        <modify-password ref="modifyPassword"></modify-password>
		<a-modal v-model="visibleAlert" centered :maskClosable="false" :keyboard="false" :closable="false" title="重要提醒！">
			<p>{{alertMsg}}</p>
			<a-button slot="footer" type="primary" @click="visibleAlert = false">我知道了</a-button>
		</a-modal>
	</header>
</template>

<script type="text/javascript">
import { mapMutations, mapGetters } from "vuex";
import modifyPassword from '@/components/common/modify-password';
import { Modal } from 'ant-design-vue';
const linkPre = (process.env.VUE_APP_REAL_ENV === 'production') ? [
	{
		text: "售票管理系统",
		link: `https://park.apailang.com`
	},
	{
		text: "课程活动系统",
		link: `https://activity.apailang.com`
	},
	{
		text: "餐饮管理系统",
		link: `https://restaurant.apailang.com`
	},
	{
		text: "租赁管理系统",
		link: `https://rent.apailang.com`
	},
	{
		text: "游玩互动系统",
		link: `https://play.apailang.com`
	},
	{
		text: "收银票台系统",
		link: `https://service.apailang.com`
	},
	] : [
	{
		text: "售票管理系统",
		link: `http://test-admin.apailang.com`
	},
	{
		text: "课程活动系统",
		link: `http://test-course.apailang.com`
	},
	{
		text: "餐饮管理系统",
		link: `http://test-meal.apailang.com`
	},
	{
		text: "租赁管理系统",
		link: `http://test-lease.apailang.com`
	},
	{
		text: "游玩互动系统",
		link: `http://test-play.apailang.com`
	},
	{
		text: "收银票台系统",
		link: `http://test-cashier.apailang.com`
	},
	]

export default {
	name: "header-component",
	props: {
		module: {
			type: String,
			default: "admin"
		}
	},
	inject: ["reload"],
	data() {
		return {
			list: linkPre,
			selectList: [],
			curStation: "",
			visible: false,
            userName: sessionStorage.getItem('username'),
            userShopId: sessionStorage.getItem('userShopId'),
			visibleErCode: false,
			visibleAppCode: false,
			visibleAlert: false,
			alertMsg: undefined
		};
	},
	components: {
		modifyPassword,
	},
	computed: {
		...mapGetters(["aside_collapsed"])
	},
	watch: {
		$route() {
			this.warning()
		}
	},
	methods: {
		...mapMutations({
			set_collapsed: "ASIDE_COLLAPSE"
		}),
		
		warning() {
			this.$api.common.staffAlert().then(res => {
				if(res) {
					this.visibleAlert = true;
					this.alertMsg = res;
				}
			})
		},

		goDetail(item) {
			window.open(item.link);
		},
		/**
		 * @getAllShopList 获取所有门店列表
		 */
		getAllShopList() {
			this.$api.home.staffShops().then(res => {
				res.unshift({
					id: '-1',
					name: '总平台'
				});
				let shopId = sessionStorage.getItem("currentShopId");
				let shopName = sessionStorage.getItem("currentShopName");
				let shopIdList = this.$userInfoTool.getUser().shopIdList;
				if (!shopIdList.find(i => i === '-1')) {
					res = res.filter(i => {
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
				}
				this.selectList = res;
				sessionStorage.setItem('shopList',JSON.stringify(res));
				if(shopName) {
					this.curStation = shopName;
					this.$store.dispatch("setShopId", shopId);
					this.$store.dispatch("setShopName", shopName);
				}else {
					this.curStation = this.selectList[0].name;
					this.$store.dispatch("setShopId", this.selectList[0].id);
					this.$store.dispatch("setShopName", this.selectList[0].name);
				}
			});
		},
		onClick({ key }) {
			this.selectList.map(item => {
				if(item.id == key) {
					this.curStation = item.name;
					sessionStorage.setItem("currentShopId", item.id);
					sessionStorage.setItem("currentShopName", item.name);
					this.$store.dispatch("setShopId", item.id);
					this.$store.dispatch("setShopName", item.name);
				}
			})
		},
		setCollapsed() {
			this.set_collapsed(!this.aside_collapsed);
		},
		loginOut() {
			sessionStorage.clear();
			this.$router.push({path: '/login'})
			this.$message.success('操作成功')
		},
		updatePassword() {
			if(!this.oldPassword) {
				this.$message.error('请输入原密码');
				return false
			}
			if(!this.newPassword) {
				this.$message.error('请输入新密码');
				return false
			}
			if(!this.newPassword2) {
				this.$message.error('请再次输入新密码');
				return false
			}
			if(this.newPassword2 !== this.newPassword) {
				this.$message.error('两次输入的新密码不一致，请重新输入');
				return false
			}
			this.$api.jurisdiction.password({
				query: {
					newPass: this.newPassword,
					oldPass: this.oldPassword,
				}
			}).then(res=>{
				this.$message.success('操作成功，请重新登录');
				this.loginOut();
			})
			// .catch(err => {
			// 	this.$message.error('操作失败，您的旧密码输入不正确');
			// });
		},
        /**
         * @更改密码
         */
        modifyPassword() {
            this.$refs.modifyPassword.open('modify');
        }
	},
	created() {},
	mounted() {
		this.getAllShopList()
		this.warning()
		this.userName = this.$userInfoTool.getUser().name;
        if (!sessionStorage.getItem('setNew')) {
            return;
        }
        setTimeout(() => {
            this.$refs.modifyPassword.open('setNew');
            sessionStorage.removeItem('setNew');
        },1000);
	}
};
</script>

<style rel="stylesheet/scss" lang="scss">
	.header-cmp {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 24px;
		height: 40px;
		background-color: #fff;
		box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
		z-index: 1000;
		.station-selector {
			&-select {
			width: 220px;
			}
		}
		.anticon {
			font-size: 20px;
			cursor: pointer;
		}
		.dropdown {
			.collapsed-icon {
				vertical-align: middle;
			}
			.ant-dropdown-link {
			color: #333;
			}
		}
		}
		.header-right {
			>span {
				cursor: pointer;
			}
			>img {
				width: 28px;
			}
		}
		.password .ant-input {
		width: 360px;
	}
</style>
